import { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';

export const useAgeHoursDependingOnDynFlag = () => {
  const { setValue, watch } = useFormContext();

  const isDynamic = watch('flags.COST_AGE_HOUR_CALC');
  const finEAgehoursPrc = watch('finEAgehoursPrc');

  useEffect(() => {
    if (isDynamic) {
      setValue('finEAgehoursPrc', 0);
    }
  }, [isDynamic]);

  useEffect(() => {
    if (!!isDynamic && finEAgehoursPrc !== 0) {
      setValue('finEAgehoursPrc', '0');
    }
  }, [finEAgehoursPrc]);
};
